import { render, staticRenderFns } from "./latesthealthdata.vue?vue&type=template&id=0f8524f0&"
import script from "./latesthealthdata.vue?vue&type=script&lang=js&"
export * from "./latesthealthdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports